@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

.spinner {
  display: inline-block;

  --thickness: 7px;

  width: var(--size);
  height: var(--size);
  border-radius: 50%;
  background: conic-gradient(from 90deg, var(--initial-color), var(--color));

  --maskCircleSize: calc(var(--size) / 2 - var(--thickness));
  --mask: radial-gradient(circle var(--maskCircleSize), transparent 100%, white 100%);

  -webkit-mask: var(--mask);
  mask: var(--mask);
  animation: rotate 1s infinite linear;
}

.large {
  --size: 48px;
}

.small {
  --size: 24px;
}

.xsmall {
  --size: 20px;
  --thickness: 4px;
}

.xxsmall {
  --size: 16px;
  --thickness: 2px;
}

.light {
  opacity: 0.4;
}

.whiteInitialColor {
  --initial-color: white;
}

.transparentInitialColor {
  --initial-color: transparent;
}

.defaultColor {
  --color: var(--color-tertiary-900);
}

.primary {
  --color: var(--color-secondary-900);
}

.secondary {
  --color: white;
}

.tertiary {
  --color: var(--color-tertiary-400);
}

.danger {
  --color: white;
}

.dangerTertiary {
  --color: var(--color-red-350);
}
